// extracted by mini-css-extract-plugin
module.exports = {"inputsSeparator":"inputs-separator_inputsSeparator__iX5JO"};